import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    title: "Đăng nhập",
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "loginAdmin",
    path: `${AUTH_PREFIX_PATH}/login-admin`,
    title: "Đăng nhập tài khoản quản trị",
    component: React.lazy(
      () => import("views/auth-views/authentication/loginAdmin"),
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    title: "Đăng ký",
    component: React.lazy(
      () => import("views/auth-views/authentication/partner-register"),
    ),
  },
  {
    key: "forgot-password",
    title: "Quên mật khẩu",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "reset-password",
    path: "/reset-password",
    title: "Đặt lại mật khẩu",
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
  },
  {
    key: "partner-register",
    path: "/partner-register",
    title: "Đăng ký",
    component: React.lazy(
      () => import("views/auth-views/authentication/partner-register/verify"),
    ),
  },
  {
    key: "paymentResult",
    title: "",
    path: "/ReturnUrl",
    component: React.lazy(() => import("views/app-views/saas/payment/index")),
  },
];

export const protectedRoutes = [
  {
    key: "admin-settings-payment-account",
    title: "Tài khoản nhận thanh toán",
    path: `${APP_PREFIX_PATH}/admin/settings/payment-account`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/payment-account"),
    ),
  },
  {
    key: "develop",
    title: "Tính năng đang phát triển",
    path: `${APP_PREFIX_PATH}/admin/manager/manager-customer`,
    component: React.lazy(() => import("views/develop")),
  },
  {
    key: "develop",
    title: "Tính năng đang phát triển",
    path: `${APP_PREFIX_PATH}/admin/manager/posts`,
    component: React.lazy(() => import("views/develop")),
  },
  {
    key: "develop",
    title: "Tính năng đang phát triển",
    path: `${APP_PREFIX_PATH}/manager/subscription`,
    component: React.lazy(() => import("views/develop")),
  },
  {
    key: "dashboard.default",
    title: "Default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards")),
  },
  {
    key: "dashboard.mergeReport",
    title: "Báo cáo hợp nhất",
    path: `${APP_PREFIX_PATH}/dashboards/mergeReport`,
    component: React.lazy(() => import("views/app-views/dashboards")),
  },
  {
    key: "admin.reports",
    title: "Báo cáo chi tiết",
    path: `${APP_PREFIX_PATH}/report-detail`,
    component: React.lazy(() => import("views/app-views/report-detail")),
  },
  {
    key: "admin.settings.store-categories",
    title: "Loại hình kinh doanh",
    path: `${APP_PREFIX_PATH}/admin/settings/store-categories`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/store-category"),
    ),
  },
  {
    key: "admin.settings.store-utilities",
    title: "Tiện ích nhà hàng",
    path: `${APP_PREFIX_PATH}/admin/settings/store-utilities`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/store-utility"),
    ),
  },
  {
    key: "admin.settings.rating-categories",
    title: "Danh mục đánh giá",
    path: `${APP_PREFIX_PATH}/admin/settings/rating-category`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/rating-category"),
    ),
  },
  {
    key: "admin.settings.group-categories",
    title: "Nhóm loại hình",
    path: `${APP_PREFIX_PATH}/admin/settings/group-category`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/group-category"),
    ),
  },
  // {
  //   key: "admin.settings.menu-categories",
  //   title: "Nhóm hàng hóa",
  //   path: `${APP_PREFIX_PATH}/admin/settings/menu-categories`,
  //   component: React.lazy(() =>
  //     import("views/app-views/admin/settings/menu-category")
  //   ),
  // },
  {
    key: "admin.settings.electronic-invoice",
    title: "Hoá đơn điện tử",
    path: `${APP_PREFIX_PATH}/admin/settings/electronic-invoice`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/electronic-invoice"),
    ),
  },
  {
    key: "admin-settings-store-banner",
    path: `${APP_PREFIX_PATH}/admin/settings/store-banner`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/admin/settings/store-banner"),
    ),
  },
  {
    key: "admin-settings-report-violation",
    path: `${APP_PREFIX_PATH}/admin/settings/report-violation`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/admin/settings/report-violation"),
    ),
  },
  {
    key: "admin-settings-word-violation",
    path: `${APP_PREFIX_PATH}/admin/settings/word-violation`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/admin/settings/word-violation"),
    ),
  },
  {
    key: "admin.settings.homepage",
    title: "Trang chủ Mobile",
    path: `${APP_PREFIX_PATH}/admin/settings/homepage`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/hompage"),
    ),
  },
  {
    key: "manager.restaurant",
    title: "Quản lý thương hiệu",
    path: `${APP_PREFIX_PATH}/manager/restaurant`,
    component: React.lazy(() => import("views/app-views/manager/restaurant")),
  },

  {
    key: "manager.organization-structure",
    title: "Cơ cấu tổ chức",
    path: `${APP_PREFIX_PATH}/manager/organization-structure`,
    component: React.lazy(() =>
      import("views/app-views/manager/organization-structure")
    ),
  },
  {
    key: "manager.role-permission",
    title: "Vai trò & Phân quyền",
    path: `${APP_PREFIX_PATH}/manager/role-permission`,
    component: React.lazy(() =>
      import("views/app-views/manager/role-permission")
    ),
  },

  {
    key: "manager.table",
    path: `${APP_PREFIX_PATH}/manager/table`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/table")),
  },
  {
    key: "manager.table.qr-code",
    path: `${APP_PREFIX_PATH}/manager/table/print-qr-code`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/manager/table/component/PrintQRCode"),
    ),
  },
  {
    key: "manager.account", // tài khoản ứng dụng
    path: `${APP_PREFIX_PATH}/manager/appaccount`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/appaccount")),
  },
  {
    key: "manager.customer",
    path: `${APP_PREFIX_PATH}/manager/customer`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/customer")),
  },
  {
    key: "manager.employee",
    path: `${APP_PREFIX_PATH}/manager/employee`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/employee")),
  },
  {
    key: "manager.partner",
    path: `${APP_PREFIX_PATH}/manager/partner`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/partner")),
  },
  {
    key: "manager.order",
    path: `${APP_PREFIX_PATH}/manager/order`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/order")),
  },
  {
    key: "manager.setting-account",
    path: `${APP_PREFIX_PATH}/manager/setting-account/*`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/manager/setting-account"),
    ),
  },
  {
    key: "manager.notification",
    path: `${APP_PREFIX_PATH}/manager/notification/*`,
    title: "",
    component: React.lazy(() => import("views/app-views/manager/notification")),
  },
  {
    key: "dashboardaccount.default",
    title: "Default",
    path: `${APP_PREFIX_PATH}/dashboardsAccount/default`,
    component: React.lazy(
      () => import("views/app-views/manager/dashboardsAccount/default"),
    ),
  },
  {
    key: "dashboardaccount.saas",
    title: "Default",
    path: `${APP_PREFIX_PATH}/dashboardsAccount/saas`,
    component: React.lazy(
      () => import("views/app-views/manager/dashboardsAccount/saas"),
    ),
  },
  {
    key: "manager.post",
    title: "Quản lí bài viết",
    path: `${APP_PREFIX_PATH}/manager/post`,
    component: React.lazy(() => import("views/app-views/manager/post")),
  },
  {
    key: "manager.post.uc",
    path: `${APP_PREFIX_PATH}/manager/post/uc`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/manager/post/Feature/CreateAndUpdate"),
    ),
  },
  {
    key: "manager.post.uc",
    path: `${APP_PREFIX_PATH}/manager/post/uc/:id`,
    title: "",
    component: React.lazy(
      () => import("views/app-views/manager/post/Feature/CreateAndUpdate"),
    ),
  },
  {
    key: "sell.pos",
    title: "",
    path: `${APP_PREFIX_PATH}/sell/pos`,
    component: React.lazy(() => import("views/app-views/sell/pos")),
  },
  {
    key: "saasSetting",
    title: "",
    path: `${APP_PREFIX_PATH}/saas/setting`,
    component: React.lazy(() => import("views/app-views/saas/setting/index")),
  },
  {
    key: "saasHistory",
    title: "",
    path: `${APP_PREFIX_PATH}/saas/history`,
    component: React.lazy(() => import("views/app-views/saas/history/index")),
  },
  {
    key: "affiliateSetting",
    title: "",
    path: `${APP_PREFIX_PATH}/affiliate/setting`,
    component: React.lazy(
      () => import("views/app-views/affiliate/setting/index"),
    ),
  },
  {
    key: "affiliatePersonal",
    title: "",
    path: `${APP_PREFIX_PATH}/affiliate/personal`,
    component: React.lazy(
      () => import("views/app-views/affiliate/affiliatePersonal/index"),
    ),
  },
  {
    key: "affiliateAgency",
    title: "",
    path: `${APP_PREFIX_PATH}/affiliate/agency`,
    component: React.lazy(
      () => import("views/app-views/affiliate/affiliateAgency/index"),
    ),
  },
  {
    key: "smenubookAI",
    title: "",
    path: `${APP_PREFIX_PATH}/admin/settings/ai`,
    component: React.lazy(
      () => import("views/app-views/admin/settings/smenubook-ai/index"),
    ),
  },
  {
    key: "admin.integrations.misa",
    title: "MISA AMIS",
    path: `${APP_PREFIX_PATH}/integrations/misa`,
    component: React.lazy(() => import("views/app-views/Providers/Misa/index")),
  },
  {
    key: "admin.warehouse",
    title: "TỔNG HỢP TỒN KHO",
    path: `${APP_PREFIX_PATH}/manager/warehouse`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/warehouse/index"),
    ),
  },
  {
    key: "admin.warehouse.import",
    title: "Nhập kho",
    path: `${APP_PREFIX_PATH}/manager/import`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/import/index"),
    ),
  },
  {
    key: "admin.warehouse.import.import-detail",
    title: "Tạo phiếu nhập kho",
    path: `${APP_PREFIX_PATH}/manager/import/detail/uc`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/import/Features/detail-import-item"),
    ),
  },
  {
    key: "admin.warehouse.import.import-detail",
    title: "Chi tiết nhập kho",
    path: `${APP_PREFIX_PATH}/manager/import/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/import/Features/detail-import-item"),
    ),
  },
  {
    key: "admin.warehouse.import.transfer-detail",
    title: "Chi tiết nhập chuyển kho",
    path: `${APP_PREFIX_PATH}/manager/import/transfer/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/import/Features/detail-transfer-item"),
    ),
  },
  {
    key: "admin.warehouse.transfer",
    title: "Xuất kho",
    path: `${APP_PREFIX_PATH}/manager/transfer/other/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/transfer/components/export-other/OtherIssueDetailPage"),
    ),
  },
  {
    key: "admin.warehouse.transfer",
    title: "Xuất kho",
    path: `${APP_PREFIX_PATH}/manager/transfer`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/transfer/index"),
    ),
  },
  {
    key: "admin.warehouse.transfer-detail",
    title: "Xuất kho",
    path: `${APP_PREFIX_PATH}/manager/transfer/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/transfer/Features/sell-out-item"),
    ),
  },
  {
    key: "admin.warehouse.transfer.transfer-detail",
    title: "Tạo phiếu xuất chuyển kho",
    path: `${APP_PREFIX_PATH}/manager/transfer/transfer-detail/uc`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/transfer/Features/detail-transfer-item"),
    ),
  },
  {
    key: "admin.warehouse.transfer.transfer-detail",
    title: "Chi tiết xuất chuyển kho",
    path: `${APP_PREFIX_PATH}/manager/transfer/transfer-detail/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/transfer/Features/detail-transfer-item"),
    ),
  },
  {
    key: "admin.warehouse.check",
    title: "Kiểm kho",
    path: `${APP_PREFIX_PATH}/manager/check`,
    component: React.lazy(
      () =>
        import("views/app-views/manager/manage-warehouse/warehouse-check/index"),
    ),
  },
  {
    key: "admin.warehouse.check.detail",
    title: "Tạo phiếu kiểm kho",
    path: `${APP_PREFIX_PATH}/manager/check/detail/uc`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/warehouse-check/Features/detail-check"),
    ),
  },
  {
    key: "admin.warehouse.check.detail",
    title: "Chi tiết kiểm kho",
    path: `${APP_PREFIX_PATH}/manager/check/detail/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/manage-warehouse/warehouse-check/Features/detail-check"),
    ),
  },
  {
    key: "admin.purchase.request-order",
    title: "Yêu cầu mua hàng",
    path: `${APP_PREFIX_PATH}/manager/request-order`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/request-order/index"),
    ),
  },
  {
    key: "admin.purchase.request-order-new",
    title: "Tạo yêu cầu mua hàng",
    path: `${APP_PREFIX_PATH}/manager/request-order/uc`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/request-order/Features/detail-request-order"),
    ),
  },
  {
    key: "admin.purchase.request-order-detail",
    title: "Chi tiết yêu cầu mua hàng",
    path: `${APP_PREFIX_PATH}/manager/request-order/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/request-order/Features/detail-request-order"),
    ),
  },
  {
    key: "admin.purchase.purchase-order",
    title: "Phiếu đặt hàng",
    path: `${APP_PREFIX_PATH}/manager/purchase-order`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/purchase-order/index"),
    ),
  },
  {
    key: "admin.purchase.purchase-order-new",
    title: "Tạo phiếu đặt hàng",
    path: `${APP_PREFIX_PATH}/manager/purchase-order/uc`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/purchase-order/components/purchase-order-detail"),
    ),
  },
  {
    key: "admin.purchase.purchase-order-detail",
    title: "Chi tiết phiếu đặt hàng",
    path: `${APP_PREFIX_PATH}/manager/purchase-order/:id`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/purchase-order/components/purchase-order-detail"),
    ),
  },
  {
    key: "admin.purchase.report",
    title: "Báo cáo mua hàng",
    path: `${APP_PREFIX_PATH}/manager/purchase-report`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/purchase-report/index"),
    ),
  },
  {
    key: "admin.purchase.supplier",
    title: "Quản lý NCC",
    path: `${APP_PREFIX_PATH}/manager/supplier-price`,
    component: React.lazy(
      () => import("views/app-views/manager/purchase/supplier-price/index"),
    ),
  },
  {
    key: "admin.purchase.supplier.price",
    title: "Quản lý nhà cung cấp",
    path: `${APP_PREFIX_PATH}/manager/supplier-price/:id`,
    component: React.lazy(
      () =>
        import("views/app-views/manager/purchase/supplier-price/components/SupplierPrice"),
    ),
  },

  //VẬT TƯ, HÀNG HÓA
  {
    key: "admin.manager.cooking-product",
    title: "Thành phẩm",
    path: `${APP_PREFIX_PATH}/manager/cooking-product`,
    component: React.lazy(() => import("views/app-views/product-material/product/product-type/cooking")),
  },
  {
    key: "admin.manager.semi-product",
    title: "Bán thành phẩm",
    path: `${APP_PREFIX_PATH}/manager/semi-product`,
    component: React.lazy(() => import("views/app-views/product-material/semi-product/index")),
  },
  {
    key: "admin.manager.material",
    title: "Nguyên vật liệu",
    path: `${APP_PREFIX_PATH}/manager/material`,
    component: React.lazy(() => import("views/app-views/product-material/material/material-type/material")),
  },
  {
    key: "admin.manager.material-tool",
    title: "Công cụ, dụng cụ",
    path: `${APP_PREFIX_PATH}/manager/material-tool`,
    component: React.lazy(() => import("views/app-views/product-material/material/material-type/material-tool")),
  },
  {
    key: "admin.manager.warehouse-product",
    title: "Hàng hóa",
    path: `${APP_PREFIX_PATH}/manager/warehouse-product`,
    component: React.lazy(() => import("views/app-views/product-material/product/product-type/warehouse")),
  },
  {
    key: "admin.manager.categories",
    title: "Nhóm vật tư, hàng hóa",
    path: `${APP_PREFIX_PATH}/manager/categories`,
    component: React.lazy(() => import("views/app-views/product-material/categories")),
  },
  {
    key: "admin.manager.units",
    title: "Đơn vị tính",
    path: `${APP_PREFIX_PATH}/manager/units`,
    component: React.lazy(() => import("views/app-views/product-material/units")),
  },
  {
    key: "admin.manager.add-option",
    title: "Tùy chọn thêm",
    path: `${APP_PREFIX_PATH}/manager/add-options`,
    component: React.lazy(() => import("views/app-views/product-material/add-options")),
  },
  {
    key: "admin.manager.other-option",
    title: "Tùy chọn khác",
    path: `${APP_PREFIX_PATH}/manager/other-options`,
    component: React.lazy(() => import("views/app-views/product-material/other-options")),
  },
    {
    key: "admin-settings-extra-costs",
    title: "Thiết lập chi phí khác",
    path: `${APP_PREFIX_PATH}/admin/settings/extra-costs`,
    component: React.lazy(() =>
      import("views/app-views/admin/settings/extra-costs"),
    ),
  },
{
    key: "manager.history",
    path: `${APP_PREFIX_PATH}/manager/history`,
    title: "Lịch sử hoạt động",
    component: React.lazy(() => import("views/app-views/manager/history")),
  },
{
    key: "printing-setting",
    path: `${APP_PREFIX_PATH}/manager/printing`,
    title: "Cài đặt mẫu in",
    component: React.lazy(() =>
      import("views/app-views/manager/printing/index")
    ),
  },
  {
    key: "product-display-setting",
    path: `${APP_PREFIX_PATH}/manager/product-display`,
    title: "Cài đặt hiển thị sản phẩm",
    component: React.lazy(() =>
      import("views/app-views/manager/product-display/index")
    ),
  },
  {
    key: "admin-calculate-loyalty",
    path: `${APP_PREFIX_PATH}/admin/manager/calculate-loyalty`,
    title: "Tích điểm",
    component: React.lazy(() =>
      import("views/app-views/manager/calculate-loyalty/index")
    ),
  },
  {
    key: "admin-voucher-price",
    path: `${APP_PREFIX_PATH}/admin/manager/voucher-price`,
    title: "Voucher khuyến mại",
    component: React.lazy(() =>
      import("views/app-views/manager/voucher-price")
    ),
  },
  {
    key: "admin-secondary-screen",
    path: `${APP_PREFIX_PATH}/admin/manager/secondary-screen`,
    title: "Thiết lập màn hình phụ",
    component: React.lazy(() =>
      import("views/app-views/manager/secondary-screen")
    ),
  },
  {
    key: "admin-secondary-screen-create",
    path: `${APP_PREFIX_PATH}/admin/manager/secondary-screen/create`,
    title: "Tạo chiến dịch màn hình phụ",
    component: React.lazy(() =>
      import("views/app-views/manager/secondary-screen/CampaignForm")
    ),
  },
  {
    key: "admin-secondary-screen-edit",
    path: `${APP_PREFIX_PATH}/admin/manager/secondary-screen/:id`,
    title: "Chỉnh sửa chiến dịch màn hình phụ",
    component: React.lazy(() =>
      import("views/app-views/manager/secondary-screen/CampaignForm")
    ),
  },
  {
    key: "brand-workflow",
    path: `${APP_PREFIX_PATH}/manager/brand-workflow`,
    title: "Quy trình thương hiệu",
    component: React.lazy(() =>
      import("views/app-views/manager/brand-workflow/index")
    ),
  },
  {
    key: "brand-order",
    path: `${APP_PREFIX_PATH}/manager/order-features`,
    title: "Tính năng đơn",
    component: React.lazy(() =>
      import("views/app-views/manager/order-features/index")
    ),
  },
];
